import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=2cca4ca8&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"
import style0 from "./prescription.vue?vue&type=style&index=0&id=2cca4ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca4ca8",
  null
  
)

export default component.exports